// extracted by mini-css-extract-plugin
export var dropdownButton = "_3q-0";
export var fullWidthDropdownButton = "_3q-1";
export var icon = "_3q-3";
export var iconPlaceholder = "_3q-2";
export var menuItemRow = "_3q-8";
export var separator = "_3q-c";
export var shortcutContainer = "_3q-7";
export var shortcutIconLg = "_3q-6";
export var shortcutIconMd = "_3q-5";
export var shortcutIconSm = "_3q-4";
export var submenuChevron = "_3q-b";
export var submenuDropdown = "_3q-9";
export var submenuTriggerRow = "_3q-a";